import { defineComponent as _defineComponent } from 'vue';
import localize from "@/utils/localization";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollectionCreatorFooterButtons',
    props: {
        validInput: { type: Boolean },
        shortWhatIsBeingCreated: null
    },
    emits: ["clicked-create", "clicked-cancel"],
    setup(__props, { emit }) {
        return { __sfc: true, emit, localize };
    }
});
